var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auction-stream-bid-button',{attrs:{"block":false,"auction":_vm.auction}})}
var staticRenderFns = []

export { render, staticRenderFns }